import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge51 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='入会審査に落ちることはあるのか' fontWeight={700} />
                <p>
                    ゴルフ会員権を購入しても、そのゴルフ場の入会審査に通らなければ会員として登録されません。頻繁にあることではありませんが、書類審査や
                    <a href='/knowledge/17'>面接</a>
                    で否認されるケースは実際に存在します。
                    <br />
                    本記事では、入会審査に落ちてしまう主な理由と、その対策について詳しくご紹介します。ゴルフ場の会員になるまでの一般的な流れについては
                    <a href='/knowledge/17'>面接に関して</a>
                    もあわせてご確認ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='入会審査に落ちる主な理由' fontWeight={700} />

                <Heading3 title='推薦人の要件を満たしていない' />
                <p>
                    ゴルフ場によっては推薦人の在籍年数や会員種別に条件を設けています。条件を満たさない推薦人しか用意できなかった場合、書類段階で受理されないことがあります。推薦者が見つからない場合の対処法は
                    <a href='/knowledge/52'>推薦者がいない場合の入会方法</a>
                    でご紹介しています。
                </p>

                <Heading3 title='面接での言動・マナー' />
                <p>
                    面接では、ゴルフ場にふさわしい人物かどうかが態度や受け答えから判断されます。横柄な態度や馴れ馴れしい発言、ドレスコードを無視した服装などは、悪い印象を与え否認の原因になり得ます。
                </p>

                <Heading3 title='入会動機が伝わらない' />
                <p>
                    「なぜそのクラブを選んだのか」という入会動機は多くのゴルフ場で重視されます。動機が曖昧だったり、クラブの雰囲気や理念への理解が感じられなかったりすると、熱意が伝わらず評価が下がることがあります。入会動機の伝え方は
                    <a href='/knowledge/53'>入会動機書の書き方・例文</a>
                    で詳しく解説しています。
                </p>

                <Heading3 title='書類の不備・虚偽記載' />
                <p>
                    入会申込書に記載する経歴やゴルフ歴に不備・誤りがあったり、事実と異なる内容を記載したりすると、審査の過程で信頼性を疑われることがあります。提出前に必ず内容を見直しましょう。
                </p>

                <Heading3 title='定員に達している・理事会のタイミングが合わない' />
                <p>
                    人物面に問題がなくても、そもそも会員の募集枠に空きがない、あるいは入会承認を行う理事会の開催時期と合わないといった、応募者側の努力だけでは解決できない事情で結果が持ち越されることもあります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='入会審査に落ちないための対策' fontWeight={700} />
                <p>
                    上記の理由を踏まえると、対策は事前準備に尽きます。信頼できる推薦人を早めに確保し、入会動機や自身のゴルフ歴を整理したうえで、面接時の服装・マナーを確認しておきましょう。
                    <br />
                    不安な点があれば、自己判断で進めず、ゴルフ会員権業者にゴルフ場ごとの審査傾向を確認しながら進めることをおすすめします。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='一度落ちてしまった場合は' fontWeight={700} />
                <p>
                    一度審査に落ちてしまっても、時間をおいて再度申し込みができる場合や、別のゴルフ場の会員権を検討する余地は十分にあります。落ちた理由を業者やゴルフ場に確認できる範囲で確認し、次の申し込みに活かしましょう。
                    <br />
                    ご購入・ご売却の際にはゴルフ会員権の売買実績を有する住地ゴルフにまずはご相談ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge51;
